import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad gäller om jag misstänker narkotikahandel i lokalen?";
const SHORT_ANSWER = "Du som tillståndshavare har ansvar att förebygga och motverka narkotikahandel. Brister i detta kan leda till varning eller återkallat tillstånd.";

export const Route = createFileRoute("/fraga/vad-galler-vid-misstankt-narkotikahandel")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad gäller om jag misstänker narkotikahandel i …" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Polisanmäl, samarbeta med polis och dokumentera åtgärder. Krögare som passivt 'tittar bort' förlorar tillståndet i fall efter fall."}
      source={{ label: "Alkohollagen (2010:1622) – Riksdagen", href: "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/alkohollag-20101622_sfs-2010-1622/" }}
      extraSources={[]}
      deepGuide={{ to: "/alkohollagen-kapitel-8", label: "Ordning, nykterhet och tillstånd" }}
      related={[{"to": "/fraga/vad-galler-vid-vald-pa-stallet", "label": "Vad gäller om det inträffar våld på serveringsstället?"}, {"to": "/fraga/ar-id-kontroll-obligatorisk", "label": "Är ID-kontroll obligatorisk vid alkoholservering?"}, {"to": "/fraga/nar-leder-sanktionsavgift", "label": "Vad är en sanktionsavgift och när tas den ut?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad gäller om jag misstänker narkotikahandel i lokalen?" },
      { name: "description", content: "Du som tillståndshavare har ansvar att förebygga och motverka narkotikahandel. Brister i detta kan leda till varning eller återkallat tillstånd." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-galler-vid-misstankt-narkotikahandel" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-galler-vid-misstankt-narkotikahandel" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-galler-vid-misstankt-narkotikahandel",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad gäller om jag misstänker narkotikahandel i …", url: "https://alkoholprovet.se/fraga/vad-galler-vid-misstankt-narkotikahandel" },
      ]),
    ],
  }),
});
